"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSelectByFeature = exports.addSelectStyleByFeature = exports.findFeaturerByName = exports.findMarkersInsideZone = exports.findFeatureSelected = exports.removeFeatureByName = exports.changeStyleByLayer = exports.visibilityLayers = exports.visibilityLayer = exports.filterLayersById = exports.removeLayersById = exports.removeLayerById = exports.checkExistLayerById = exports.changeStyleByFeature = exports.findIncludeLayerById = exports.findLayerById = exports.addLayerToMap = exports.setOpacityLayer = exports.isIntersect = exports.divideGeometry = exports.parseWKT = exports.getExtensionOl = exports.getExtension = exports.polygonToMultiPolygonWKT = void 0;
const Vector_1 = __importDefault(require("ol/source/Vector"));
const geom_1 = require("ol/geom");
const style_1 = require("ol/style");
const WKT_1 = __importDefault(require("ol/format/WKT"));
const olSphere = __importStar(require("ol/sphere"));
function polygonToMultiPolygonWKT(polygonWKT) {
    if (polygonWKT.startsWith("MULTIPOLYGON")) {
        return polygonWKT;
    }
    if (!polygonWKT.startsWith("POLYGON")) {
        throw new Error("El WKT proporcionado no es un POLYGON válido");
    }
    const coordsString = polygonWKT.replace("POLYGON((", "").replace("))", "");
    const coordinates = coordsString.split(',').map(coordPair => {
        const [lon, lat] = coordPair.trim().split(' ').map(Number);
        return [lon, lat];
    });
    const polygon = new geom_1.Polygon([coordinates]);
    const multiPolygon = new geom_1.MultiPolygon([polygon.getCoordinates()]);
    const multiPolygonCoordinates = multiPolygon.getCoordinates();
    const wkt = `MULTIPOLYGON(${multiPolygonCoordinates
        .map(polygonRings => `((${polygonRings
        .map(ring => ring.map(coord => coord.join(' ')).join(','))
        .join('),(')}))`)
        .join(',')})`;
    return wkt;
}
exports.polygonToMultiPolygonWKT = polygonToMultiPolygonWKT;
function getExtension(geodata) {
    const projections = { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    const feature = new WKT_1.default().readFeature(geodata, projections);
    const geometry = feature.getGeometry();
    return olSphere.getArea(geometry);
}
exports.getExtension = getExtension;
function getExtensionOl(geodata) {
    const projections = { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    const feature = new WKT_1.default().readFeature(geodata, projections);
    const geometry = feature.getGeometry();
    const extent = geometry.getExtent();
    return extent;
}
exports.getExtensionOl = getExtensionOl;
function parseWKT(wkt) {
    const format = new WKT_1.default();
    return format.readFeature(wkt).getGeometry();
}
exports.parseWKT = parseWKT;
function divideGeometry(geodata) {
    const polygons = geodata.split(')),((');
    return polygons.map((polygon) => 'POLYGON((' + polygon.replace('MULTIPOLYGON(((', '') + '))');
}
exports.divideGeometry = divideGeometry;
function isIntersect(feature1, feature2) {
    const geometry1 = feature1.getGeometry();
    const geometry2 = feature2.getGeometry();
    let intersect = false;
    if (geometry2 instanceof geom_1.Point) {
        if (geometry1.intersectsCoordinate(geometry2.getCoordinates())) {
            intersect = true;
        }
    }
    return intersect;
}
exports.isIntersect = isIntersect;
function setOpacityLayer(idLayer, opacity, map) {
    findLayerById(idLayer, map).setOpacity(opacity / 100);
}
exports.setOpacityLayer = setOpacityLayer;
function addLayerToMap(layer, id, zIndex, map) {
    layer.setZIndex(zIndex);
    layer.set('id', id);
    map.addLayer(layer);
}
exports.addLayerToMap = addLayerToMap;
function findLayerById(id, map) {
    const mapLayers = map.getLayers().getArray();
    return mapLayers.find((layer) => layer.get('id') === id);
}
exports.findLayerById = findLayerById;
function findIncludeLayerById(id, map) {
    const mapLayers = map.getLayers().getArray();
    return mapLayers.filter((layer) => layer.get('id').includes(id));
}
exports.findIncludeLayerById = findIncludeLayerById;
function changeStyleByFeature(featureName, newStyle, map) {
    findFeaturerByName(featureName, map).setStyle(newStyle);
}
exports.changeStyleByFeature = changeStyleByFeature;
function checkExistLayerById(id, map) {
    const mapLayers = map.getLayers().getArray();
    const layersFound = mapLayers.filter((layer) => layer.get('id') === id);
    if (layersFound.length)
        return true;
    return false;
}
exports.checkExistLayerById = checkExistLayerById;
function removeLayerById(layerId, map) {
    const mapLayers = map.getLayers().getArray();
    const layersFound = mapLayers.filter((layer) => layer.get('id') === layerId);
    layersFound.forEach((layer) => map.removeLayer(layer));
}
exports.removeLayerById = removeLayerById;
function removeLayersById(layerId, map) {
    const mapLayers = map.getLayers().getArray();
    const layersFound = mapLayers.filter((layer) => layer.get('id').includes(layerId));
    layersFound.forEach((layer) => map.removeLayer(layer));
}
exports.removeLayersById = removeLayersById;
function filterLayersById(id, map) {
    const mapLayers = map.getLayers().getArray();
    return mapLayers.filter((layer) => layer.get('id').includes(id));
}
exports.filterLayersById = filterLayersById;
function visibilityLayer(visibility, layerId, map) {
    const mapLayers = map.getLayers().getArray();
    const layersFound = mapLayers.filter((layer) => layer.get('id') === layerId);
    layersFound.forEach((layer) => layer.setVisible(visibility));
}
exports.visibilityLayer = visibilityLayer;
function visibilityLayers(visibility, layerId, map) {
    const mapLayers = map.getLayers().getArray();
    const layersFound = mapLayers.filter((layer) => layer.get('id').includes(layerId));
    layersFound.forEach((layer) => layer.setVisible(visibility));
}
exports.visibilityLayers = visibilityLayers;
function changeStyleByLayer(layerId, newStyle, map) {
    var _a;
    (_a = findLayerById(layerId, map)) === null || _a === void 0 ? void 0 : _a.getSource().getFeatures().forEach((feature) => {
        feature.setStyle(newStyle);
        feature.set('style', newStyle);
    });
}
exports.changeStyleByLayer = changeStyleByLayer;
function removeFeatureByName(layer, featureName) {
    // Verificar si el layer tiene una fuente (source)
    var source = layer.getSource();
    if (!source) {
        console.log('El layer no tiene source');
        return;
    }
    // Obtener todos los features del source
    var features = source.getFeatures();
    console.log('Features disponibles:', features);
    // Buscar el feature que tiene la propiedad 'name' igual al valor de 'featureName'
    var featureToRemove = features.find(function (feature) {
        // Asegúrate de que la propiedad 'name' está presente y es correcta
        console.log('Revisando feature:', feature);
        return feature.get('name') === featureName;
    });
    // Si encontramos el feature, lo eliminamos
    if (featureToRemove) {
        source.removeFeature(featureToRemove);
        console.log('Feature eliminado:', featureToRemove);
    }
    else {
        console.log('Feature no encontrado con el nombre:', featureName);
    }
}
exports.removeFeatureByName = removeFeatureByName;
function findFeatureSelected(layerId, map) {
    let findFeature;
    const mapLayers = map.getLayers().getArray();
    mapLayers.forEach((layer) => {
        const source = layer.getSource();
        if (source instanceof Vector_1.default) {
            const features = source.getFeatures();
            if (features) {
                for (const feature of features) {
                    if (feature.get('isSelected') === true && feature.get('layerId') === layerId) {
                        findFeature = feature;
                        break;
                    }
                }
            }
        }
        if (findFeature)
            return;
    });
    return findFeature;
}
exports.findFeatureSelected = findFeatureSelected;
function findMarkersInsideZone(zoneFeature, map) {
    const markersInside = [];
    const pointLayer = findLayerById('point-layer', map);
    if (pointLayer) {
        pointLayer.getSource().getFeatures().forEach((pointFeature) => {
            if (isIntersect(zoneFeature, pointFeature)) {
                markersInside.push(pointFeature);
            }
        });
        return markersInside;
    }
    else {
        return [];
    }
}
exports.findMarkersInsideZone = findMarkersInsideZone;
function findFeaturerByName(name, map) {
    let findFeature;
    const mapLayers = map.getLayers().getArray();
    mapLayers.forEach((layer) => {
        const source = layer.getSource();
        if (source instanceof Vector_1.default) {
            const features = source.getFeatures();
            if (features) {
                for (const feature of features) {
                    if (feature.get('name') === name) {
                        findFeature = feature;
                        break;
                    }
                }
            }
        }
        if (findFeature)
            return;
    });
    return findFeature;
}
exports.findFeaturerByName = findFeaturerByName;
function addSelectStyleByFeature(featureName, overlayBuilder, map, zoneTooltipId) {
    const feature = findFeaturerByName(featureName, map);
    const style = new style_1.Style({
        fill: new style_1.Fill({ color: feature.get('style').getFill().getColor() }),
        stroke: new style_1.Stroke({ color: '#fff', width: 4 }),
        zIndex: 20,
    });
    feature.setStyle(style);
    const geometry = feature.getGeometry();
    if (geometry instanceof geom_1.Polygon || geometry instanceof geom_1.MultiPolygon) {
        const coordinates = geometry.getCoordinates();
        let maxX = -Infinity;
        let maxY = -Infinity;
        let rightmostAndHighestPoint = null;
        const processCoordinates = (coords) => {
            coords.forEach(coord => {
                const x = coord[0]; // La coordenada X (longitud normalmente)
                const y = coord[1]; // La coordenada Y (latitud normalmente)
                // Comparamos primero el valor de X para encontrar el más a la derecha
                // Si dos puntos tienen el mismo X, comparamos Y para encontrar el más alto
                if (x > maxX || y > maxY) {
                    maxX = x > maxX ? x : maxX;
                    maxY = y > maxY ? y : maxY;
                    rightmostAndHighestPoint = [maxX, maxY]; // Guardar la nueva coordenada
                }
            });
        };
        if (geometry instanceof geom_1.Polygon) {
            coordinates.forEach(ring => processCoordinates(ring));
        }
        else if (geometry instanceof geom_1.MultiPolygon) {
            coordinates.forEach(polygon => polygon.forEach(ring => processCoordinates(ring)));
        }
        if (rightmostAndHighestPoint) {
            overlayBuilder.addOverlay(zoneTooltipId, rightmostAndHighestPoint);
        }
    }
    overlayBuilder.visibilityOverlay(zoneTooltipId, true);
    return feature;
}
exports.addSelectStyleByFeature = addSelectStyleByFeature;
function addSelectByFeature(featureName, overlayBuilder, map, zoneTooltipId) {
    const feature = findFeaturerByName(featureName, map);
    const geometry = feature.getGeometry();
    if (geometry instanceof geom_1.Polygon || geometry instanceof geom_1.MultiPolygon) {
        const coordinates = geometry.getCoordinates();
        let maxX = -Infinity;
        let maxY = -Infinity;
        let rightmostAndHighestPoint = null;
        const processCoordinates = (coords) => {
            coords.forEach(coord => {
                const x = coord[0]; // La coordenada X (longitud normalmente)
                const y = coord[1]; // La coordenada Y (latitud normalmente)
                // Comparamos primero el valor de X para encontrar el más a la derecha
                // Si dos puntos tienen el mismo X, comparamos Y para encontrar el más alto
                if (x > maxX || y > maxY) {
                    maxX = x > maxX ? x : maxX;
                    maxY = y > maxY ? y : maxY;
                    rightmostAndHighestPoint = [maxX, maxY]; // Guardar la nueva coordenada
                }
            });
        };
        // Procesar las coordenadas del polígono o multipolígono
        if (geometry instanceof geom_1.Polygon) {
            coordinates.forEach(ring => processCoordinates(ring)); // Proceso de cada anillo
        }
        else if (geometry instanceof geom_1.MultiPolygon) {
            coordinates.forEach(polygon => polygon.forEach(ring => processCoordinates(ring))); // Proceso de cada anillo en cada polígono
        }
        // Si se ha encontrado el punto más a la derecha y más alto
        if (rightmostAndHighestPoint) {
            overlayBuilder.addOverlay(zoneTooltipId, rightmostAndHighestPoint);
        }
    }
    overlayBuilder.visibilityOverlay(zoneTooltipId, true);
    return feature;
}
exports.addSelectByFeature = addSelectByFeature;
